import { useState, useMemo } from 'react';
import { RegistrationFlow, SignUpFlowValidationRules } from '../constants';
import { RegistrationFlowState } from '../types';

export const useRegistrationUserDetails = <T extends RegistrationFlow>(
  flowType: T,
) => {
  const { defaultValues, requiredFields } = SignUpFlowValidationRules[flowType];

  const [userDetails, setUserDetails] =
    useState<RegistrationFlowState[T]>(defaultValues);

  const validation = useMemo(() => {
    const errors: Partial<Record<keyof RegistrationFlowState[T], string>> = {};
    const isValid = requiredFields.every(field => !!userDetails[field]);

    requiredFields.forEach(field => {
      if (!userDetails[field]) {
        errors[field] = `${String(field)} is required`;
      }
    });

    return { isValid, errors };
  }, [userDetails, requiredFields]);

  const updateUserDetails = (newDetails: Partial<RegistrationFlowState[T]>) => {
    setUserDetails((prevDetails: RegistrationFlowState[T]) => ({
      ...prevDetails,
      ...newDetails,
    }));
  };

  return { userDetails, updateUserDetails, validation };
};
